import { Cards } from "/react4xp/parts/cards/cards";

export default (props) => <Cards {...props} />